/**
 * Picks one language's copy from a small inline table, for components whose
 * text is easier to keep next to the JSX than as dozens of message ids.
 *
 * Anything that is not `en*` or `zh` reads as Traditional Chinese — including a
 * missing locale, which is what the component tests' stub `intl` gives.
 */
export type CopyLocale = 'zh-Hant-HK' | 'zh' | 'en';

export const copyLocaleOf = (locale?: string | null): CopyLocale =>
  locale === 'zh' ? 'zh' : locale?.startsWith('en') ? 'en' : 'zh-Hant-HK';

export const pickCopy = <T>(table: Record<CopyLocale, T>, locale?: string | null): T => table[copyLocaleOf(locale)];
